import { render, staticRenderFns } from "./ProductAgency.vue?vue&type=template&id=a52159cc&"
import script from "./ProductAgency.vue?vue&type=script&lang=js&"
export * from "./ProductAgency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports